<div *ngIf="zone === 'onboarding'" class="col element-zoom m-0 pointer-events-none" [ngStyle]="contentStyle">
  <div
    class="widget-wrapper"
    [ngClass]="isStepComplete ? 'step-complete' : isError ? 'error' : 'open'"
    [ngStyle]="borderStyle"
    style="min-height: 100%"
  >
    <div class="title-wrapper">
      <div class="title">
        <p [ngStyle]="colorTextAlignStyle">
          <span [innerHTML]="widgetConfig.attributes['sub_heading'] | safeHtml"> </span>
        </p>
      </div>
      <div *ngIf="birthdayForm.valid && isBirthdayShowSuccessIcon">
        <img
          src="../../../../../../../../../assets/images/check-circle.svg"
          alt="check-circle"
          class="img-fluid"
        />
      </div>
      <div *ngIf="!isStepComplete && isError && isShowErrorMsg && isBirthdayShowErrorIcon" class="error-msg">
        <img
          src="../../../../../../../../../assets/images/exclamation-circle.svg"
          alt="check-circle"
          class="img-fluid"
        />
        <label>Age Restriction</label>
        <p>You need to be at least {{ minAge }} years old to meet the criteria.</p>
      </div>
    </div>
    <div class="form-wrapper">
      <form [formGroup]="birthdayForm">
        <div class="error-wrapper" *ngIf="isError">
          <div class="text-error">
            <img
              src="../../../../../../../../../assets/images/exclamation-circle.svg"
              alt="check-circle"
              class="img-fluid"
            />
            <p>You need to be at least {{ minAge }} years old to meet the criteria.</p>
          </div>
        </div>
        <div
          class="form-group custom-calender"
          *ngFor="let field of widgetConfig.attributes['field_attributes']"
        >
          <ng-container *ngIf="field.type !== 'dropdown'">
            <finx-date-picker
              *ngIf="widgetConfig.attributes?.widgetProperties?.dateType === datepickerTypes.DATEPICKER"
              placeholder=""
              dateFormat="yy-mm-dd"
              icon="pi pi-calendar-plus"
              class="datepicker-calendar"
              [inline]="true"
              [formControlName]="field.name"
              [maxDate]="maxDate"
              [ngModelValue]="birthdayFormValue[field.name]"
              [inputStyle]="inputFieldDayStyle"
              [textColor]="colorStyle"
              (focusEvent)="updateInputFieldCurrentStyles($event, 'day')"
              [textInputFontStyle]="textInputFontStyle"
            ></finx-date-picker>
            <div
              *ngIf="widgetConfig.attributes?.widgetProperties?.dateType === datepickerTypes.INPUT"
              class="show-date-picker-input"
            >
              <form class="bithday-form is-center" [formGroup]="inputDatePickerForm">
                <div class="mr-4">
                  <finx-input
                    type="text"
                    [inputMode]="'decimal'"
                    class="profile-input"
                    [labelAsPlaceholder]="pageConfig?.labelsAsPlaceholder"
                    [label]="'Day'"
                    [maxLength]="2"
                    [value]="selectedDay"
                    [colorTextAlignStyle]="colorTextAlignStyle"
                    formControlName="day"
                    [textInputFontStyle]="textInputFontStyle"
                    [inputStyle]="inputFieldDayStyle"
                    [textInputBackgroundColor]="textInputBackgroundColor"
                    (focusInput)="resetDay()"
                    (focusEvent)="updateInputFieldCurrentStyles($event, 'day')"
                  ></finx-input>
                </div>

                <div class="mr-4 month-dropdown">
                  <finx-dropdown
                    class="phone-dropdown dropdown-with-border"
                    [options]="allmonths"
                    appendto="body"
                    label="name"
                    id="key"
                    [value]="selectedMonth"
                    formControlName="month"
                    [placeholderAsLabel]="!pageConfig?.labelsAsPlaceholder"
                    [placeholder]="'Month'"
                    [colorTextAlignStyle]="colorTextAlignStyle"
                    [textInputFontStyle]="textInputFontStyle"
                    [inputStyle]="inputFieldMonthStyle"
                    (focusEvent)="updateInputFieldCurrentStyles($event, 'month')"
                  >
                  </finx-dropdown>
                </div>
                <div>
                  <finx-input
                    type="text"
                    [inputMode]="'decimal'"
                    class="profile-input"
                    [value]="selectedYear"
                    formControlName="year"
                    [maxLength]="4"
                    [labelAsPlaceholder]="pageConfig?.labelsAsPlaceholder"
                    [label]="'Year'"
                    [colorTextAlignStyle]="colorTextAlignStyle"
                    [textInputFontStyle]="textInputFontStyle"
                    (focusInput)="resetYear()"
                    (focusEvent)="updateInputFieldCurrentStyles($event, 'year')"
                    [inputStyle]="inputFieldYearStyle"
                  ></finx-input>
                </div>
              </form>
            </div>

            <ng-container
              *ngTemplateOutlet="inputDateInputForm; context: { inputDatePickerForm: inputDatePickerForm }"
            ></ng-container>
          </ng-container>
        </div>
        <div class="form-group is-center" *ngIf="isAnyFieldRequired">
          <span>
            <img
              src="../../../../../../../../../assets/images/exclamation-circle-gray.svg"
              alt="check-circle"
              class="img-fluid"
          /></span>
          <span class="validation-need-text"
            >Date of birth needs to meet minimum criteria before proceeding to the next step.</span
          >
        </div>
        <div
          class="form-group m-0 is-hidden"
          style="position: fixed; bottom: 1em; left: 1em; width: calc(100% - 2em)"
        >
          <finx-button
            type="button"
            class="btn w-100 mt-2"
            labeltext="Confirm"
            (click)="onSubmit()"
          ></finx-button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- desgin profile -->
<div
  *ngIf="zone === 'profile' || zone === 'verification'"
  class="col element-zoom profile-page"
  [ngStyle]="combinedContentAndBorderStyles"
  style="height: 100%"
>
  <div class="form-wrapper collapsed" style="height: 100%">
    <form [formGroup]="birthdayForm" style="height: 100%">
      <div class="error-wrapper" *ngIf="isError">
        <div class="text-error">
          <img
            src="../../../../../../../../../assets/images/exclamation-circle.svg"
            alt="check-circle"
            class="img-fluid"
          />
          <p>You need to be at least {{ minAge }} years old to meet the criteria.</p>
        </div>
      </div>
      <div
        class="form-group custom-calender"
        *ngFor="let field of widgetConfig.attributes['field_attributes']"
      >
        @if (zone === 'profile') {
        <label [ngStyle]="colorTextAlignStyle" for="fname">{{ field.label }}</label>
        }
        <ng-container *ngIf="field.type !== 'dropdown'">
          @if (widgetConfig.attributes['sub_heading']) {
          <label>{{ widgetConfig.attributes['sub_heading'] }}</label>
          }
          <finx-date-picker
            *ngIf="widgetConfig.attributes?.widgetProperties?.dateType === datepickerTypes.DATEPICKER"
            placeholder="--/--"
            [dateFormat]="'dd-mm-yy'"
            icon="pi pi-calendar-plus"
            [class]="'custom-datepicker-profile'"
            class="datepicker-calendar"
            [formControlName]="field.name"
            [maxDate]="maxDate"
            [ngModelValue]="birthdayForm.get(field.name)?.value"
            [append]="'body'"
            [textColor]="colorStyle"
            [inputStyle]="inputFieldDayStyle"
            (focusEvent)="updateInputFieldCurrentStyles($event, 'day')"
            [textInputFontStyle]="textInputFontStyle"
            [textInputBackgroundColor]="textInputBackgroundColor"
          ></finx-date-picker>

          <div
            *ngIf="widgetConfig.attributes?.widgetProperties?.dateType === datepickerTypes.INPUT"
            class="show-date-picker-input"
          >
            <form class="bithday-form is-center" [formGroup]="inputDatePickerForm">
              <div class="mr-4">
                <finx-input
                  type="number"
                  [textColor]="colorStyle"
                  class="profile-input"
                  [labelAsPlaceholder]="pageConfig?.labelsAsPlaceholder"
                  [label]="'Day'"
                  [maxLength]="2"
                  [value]="selectedDay"
                  [colorTextAlignStyle]="colorTextAlignStyle"
                  [textInputFontStyle]="textInputFontStyle"
                  [inputStyle]="inputFieldDayStyle"
                  (keyup)="valueChangesTrigger()"
                  formControlName="day"
                ></finx-input>
              </div>

              <div class="mr-4">
                <finx-dropdown
                  [textColor]="colorStyle"
                  class="phone-dropdown dropdown-with-border"
                  [className]="''"
                  [options]="allmonths"
                  appendto="body"
                  label="name"
                  id="key"
                  [value]="selectedMonth"
                  formControlName="month"
                  [placeholderAsLabel]="!pageConfig?.labelsAsPlaceholder"
                  [placeholder]="'Month'"
                  [colorTextAlignStyle]="colorTextAlignStyle"
                  [textInputFontStyle]="textInputFontStyle"
                  [inputStyle]="inputFieldMonthStyle"
                  (keyup)="valueChangesTrigger()"
                >
                </finx-dropdown>
              </div>
              <div class="mr-4">
                <finx-input
                  type="number"
                  [textColor]="colorStyle"
                  class="profile-input"
                  [value]="selectedYear"
                  formControlName="year"
                  [labelAsPlaceholder]="pageConfig?.labelsAsPlaceholder"
                  [label]="'Year'"
                  [colorTextAlignStyle]="colorTextAlignStyle"
                  [textInputFontStyle]="textInputFontStyle"
                  [inputStyle]="inputFieldYearStyle"
                  (focusInput)="resetYear()"
                  (keyup)="valueChangesTrigger()"
                ></finx-input>
              </div>
            </form>
          </div>
          <ng-container
            *ngTemplateOutlet="inputDateInputForm; context: { inputDatePickerForm: inputDatePickerForm }"
          ></ng-container>
        </ng-container>
      </div>
    </form>
  </div>
</div>
<ng-template #inputDateInputForm let-inputDatePickerForm="inputDatePickerForm">
  <div
    class="date-error-msg typog-sm"
    *ngIf="inputDatePickerForm?.errors?.['error'] && !year?.errors?.['min'] && !year?.errors?.['max']"
  >
    <div class="text-error">
      {{ inputDatePickerForm.errors?.['error'] }}
    </div>
  </div>

  <div
    class="date-error-msg typog-sm"
    *ngIf="year?.errors?.['min'] || year?.errors?.['max'] || inputDatePickerForm?.errors?.['minlength']"
  >
    <div class="text-error">Year must be between {{ minYear }} and {{ maxYear }}</div>
  </div>
  <div
    class="date-error-msg typog-sm"
    *ngIf="!inputDatePickerForm?.errors?.['error'] && day?.errors?.['min']  "
  >
    <div class="text-error">Day number not valid</div>
  </div>
</ng-template>
